<div class="filter-element">
  <div class="form-group mb-0" style="min-width: 280px;">

    <div class="input-group">
      <div class="input-group-prepend">
        <span [innerHtml]="'Show' | translate" class="input-group-text"></span>
      </div>
      <ng-select #signalSelect [style.width.px]="300"
        [(ngModel)]="statusEventPageActionsParameters.visibleStatusEventSignals"
        [items]="availableStatusEventSignals"
        [loading]="isLoading"
        [multiple]="true"
        [closeOnSelect]="false"
        bindLabel="label"
        bindValue="name"
        labelForId="signalSelect"
        [placeholder]="'Select signals....' | translate">
        <ng-template ng-header-tmp>
          <div class="form-row align-items-center">
            <div class="col-6">
              <button (click)="onSelectAll()" class="btn btn-outline-primary btn-sm btn-block">
                <span [innerHtml]="'Select all' |translate"></span>
              </button>
            </div>
            <div class="col-6">
              <button (click)="onClearAll()" class="btn btn-outline-primary btn-sm btn-block">
                <span [innerHtml]="'Clear' |translate"></span>
              </button>
            </div>
          </div>
        </ng-template>

        <ng-template let-clear="clear" let-items="items" ng-multi-label-tmp>
          @if (items.length > 0) {
            <div class="ng-value">
              <span class="ng-value-label">
                <strong [innerText]="items.length" class="mr-1"></strong>
                <span translate>Signal(s)</span>
              </span>
            </div>
          }
        </ng-template>

        <ng-template let-item="item" ng-option-tmp>
          <div class="row">
            <div class="col">
              <strong [innerHtml]="item.name" class="d-block"></strong>
              <span [innerHtml]="item.label | translate" class="d-block small text-muted"></span>
            </div>
          </div>
        </ng-template>

        <ng-template ng-footer-tmp>
          <button (click)="onApplySignalFilter();signalSelect.close()" class="btn btn-block btn-primary" translate>
            Apply
          </button>
        </ng-template>
      </ng-select>


    </div>
  </div>
</div>

<div class="filter-element">

  <div #dropdownStatus="ngbDropdown" ngbDropdown>
    <button class="btn btn-outline-primary" id="dropdownStatus" ngbDropdownToggle>
      <span class="fa-solid fa-filter"></span>
      <span translate>Filter</span>
    </button>

    <div aria-labelledby="dropdownManual" class="p-3" ngbDropdownMenu>

      <h6 class="dropdown-header px-0" translate>Show types</h6>

      <div class="checkbox-list">
        <div class="form-group form-check text-danger">
          <input (change)="onErrorCheckboxChange($event)" [checked]="showErrorEvents" class="form-check-input"
            id="errorCheckbox"
            type="checkbox">
            <label class="form-check-label" for="errorCheckbox">
              <span translate>Error</span>
              <span class="fa-solid fa-triangle-exclamation"></span>
            </label>
          </div>

          <div class="form-group form-check text-warning">
            <input (change)="onWarningCheckboxChange($event)" [checked]="showWarningEvents" class="form-check-input"
              id="warningCheckbox"
              type="checkbox">
              <label class="form-check-label" for="warningCheckbox">
                <span translate>Warning</span>
                <span class="fa-solid fa-circle-exclamation"></span>
              </label>
            </div>

            <div class="form-group form-check text-info">
              <input (change)="onInfoCheckboxChange($event)" [checked]="showInfoEvents" class="form-check-input"
                id="infoCheckbox"
                type="checkbox">
                <label class="form-check-label" for="infoCheckbox">
                  <span translate>Info</span>
                  <span class="fa-solid fa-circle-info"></span>
                </label>
              </div>

              <div class="form-group form-check text-debug">
                <input (change)="onDebugCheckboxChange($event)" [checked]="showDebugEvents" class="form-check-input"
                  id="debugCheckbox"
                  type="checkbox">
                  <label class="form-check-label" for="debugCheckbox">
                    <span translate>Debug</span>
                    <span class="fa-solid fa-gear"></span>
                  </label>
                </div>

                <div class="form-group form-check">
                  <input (change)="onInhibitCheckboxChange($event)" [checked]="showInhibitEvents" class="form-check-input"
                    id="inhibitCheckbox"
                    type="checkbox">
                    <label class="form-check-label" for="inhibitCheckbox">
                      <span translate>Inhibit</span>
                      <span class="fa-solid fa-ban"></span>
                    </label>
                  </div>
                </div>

                <button (click)="onFilterByEventType(); dropdownStatus.close();" class="btn btn-block btn-primary" translate>
                  Apply
                </button>
              </div>
            </div>
          </div>

          <div class="filter-element d-none d-md-flex">
            <div ngbDropdown>
              <button class="btn btn-outline-primary" id="dropdownManual" ngbDropdownToggle>
                <span [innerHTML]="'Functions' | translate"></span>
              </button>

              <div aria-labelledby="dropdownManual" ngbDropdownMenu>
                <button (click)="onCopyPage()" [disabled]="!isAdminOrHigher" ngbDropdownItem>

                  @if (isTemplatePage) {
                    <span class="fa-solid fa-right-left"></span>
                  }
                  @if (isTemplatePage) {
                    <span translate>Copy as Status event page</span>
                  }

                  @if (!isTemplatePage) {
                    <span class="fa-solid fa-clone"></span>
                  }
                  @if (!isTemplatePage) {
                    <span translate>Copy page</span>
                  }
                </button>

                <button (click)="onEditPage()" [disabled]="isAdminOrLower" ngbDropdownItem>
                  <span class="fa-solid fa-gear"></span>
                  <span translate>Edit page</span>
                </button>

                @if (isTemplatePage) {
                  <div class="dropdown-menu-footer">
                    <div class="custom-control custom-switch">
                      <input #syncTemplate (change)="onSyncTemplatePage()" [checked]="syncTemplatePage"
                        [disabled]="isLoading || isAdminOrLower"
                        class="custom-control-input"
                        id="syncTemplatePage"
                        type="checkbox">
                        <label class="custom-control-label" for="syncTemplatePage" translate>Enable Template Synchronization</label>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
